import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { themeState } from '../Recoil/RecoilState';

const THEME_STORAGE_KEY = 'app-theme-mode';

export const useThemePersistence = () => {
  const [themeMode, setThemeMode] = useRecoilState(themeState);

  // Load theme from localStorage on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    if (savedTheme && ['light', 'dark', 'highContrast'].includes(savedTheme)) {
      setThemeMode(savedTheme);
    }
  }, [setThemeMode]);

  // Save theme to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(THEME_STORAGE_KEY, themeMode);
  }, [themeMode]);

  return [themeMode, setThemeMode];
}; 